// extracted by mini-css-extract-plugin
export var aircallIframe = "_ih-3";
export var fabContainer = "_ih-5";
export var fabRinging = "_ih-6";
export var loadingOverlay = "_ih-4";
export var pulse = "_ih-7";
export var widgetContent = "_ih-2";
export var widgetPanel = "_ih-0";
export var widgetPanelExpanded = "_ih-1";